import { authStoreUserTournamentId } from 'modules/auth/store/selectors';
import { useAuth } from 'modules/auth/ui/hooks/use-auth';
import { fetchOrganizer } from 'modules/organizer/store/organizer/actions';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useOrganizer } from './use-organizer';
import { useRefetchOrganizer } from './use-refetch-organizer';

export const useFetchOrganizer = () => {
  const dispatch = useDispatch();
  const tournamentId = useSelector(authStoreUserTournamentId);
  const { hasTournaments } = useAuth();
  const { isLoading, loadedTournamentId } = useOrganizer();

  const refetch = useRefetchOrganizer();

  useEffect(() => {
    // Сравниваем именно id: после неудачной загрузки `loadedTournamentId` равен текущей
    // организации, и эффект молчит (повтор — кнопкой «Повторить»), но смена организации
    // перезапрашивает данные даже при пустом `info`.
    if (hasTournaments && tournamentId && !isLoading && loadedTournamentId !== tournamentId) {
      dispatch(fetchOrganizer({ tournamentId }));
    }
    // Important: do not refetch organizer when only pagination params change to avoid UI flicker
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, loadedTournamentId, isLoading, tournamentId, hasTournaments]);

  return { refetch };
};
